package com.eladfinish.bible.contest.ui.text

import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.text.BasicText
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.TextLayoutResult
import androidx.compose.ui.text.TextStyle

/**
 * Replacement for deprecated ClickableText:
 * - Works on Compose Multiplatform
 * - Uses StringAnnotations (your CLICK_TAG approach)
 */
@Composable
fun BasicTextWithInlineClicks(
    text: AnnotatedString,
    modifier: Modifier = Modifier,
    style: TextStyle = TextStyle.Default,
    onClickOffset: (offset: Int) -> Unit,
) {
    val layoutResult = remember { mutableStateOf<TextLayoutResult?>(null) }

    BasicText(
        text = text,
        modifier = modifier.pointerInput(Unit) {
            detectTapGestures { pos ->
                val offset = layoutResult.value?.getOffsetForPosition(pos) ?: return@detectTapGestures
                onClickOffset(offset)
            }
        },
        style = style,
        onTextLayout = { layoutResult.value = it },
    )
}
